import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetTitleProvidersByShortNamesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	platform: Types.Platform;
}>;

export type GetTitleProvidersByShortNamesQuery = { __typename?: 'Query' } & {
	packages: Array<{ __typename?: 'Package' } & Pick<Types.Package, 'shortName'>>;
};

export const GetTitleProvidersByShortNamesDocument = gql`
	query GetTitleProvidersByShortNames($country: Country!, $platform: Platform!) {
		packages(country: $country, platform: $platform, hasTitles: true) {
			shortName
		}
	}
`;
